import { CheckBoxList } from '../../../base';
import { useLookupRoleScopes } from '../useLookupRoleScopes';

type ICheckedBoxListRoleScopeProps = {
	name: string;
	selectedValue: any[];
	onSelectionChanged: (values: any[]) => void;
	label?: string;
	labelSmall?: boolean;
	hasValid?: boolean;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
};

export const CheckedBoxListRoleScope = (props: ICheckedBoxListRoleScopeProps) => {
	const { label, labelSmall, hasValid } = props;
	const { role_scopes_lookup } = useLookupRoleScopes();
	return (
		<>
			<div className='space-y-2'>
				{label && (
					<div>
						<label className={`text-sm font-medium text-foreground ${labelSmall ? 'text-xs' : ''}`}>
							{label} {hasValid && <em className='text-danger'>(*)</em>}
						</label>
					</div>
				)}
				<div className='w-full'>
					<CheckBoxList dataSource={role_scopes_lookup} displaySubExpr='description' displayExpr='name' keyExpr='id' {...props} />
				</div>
			</div>
		</>
	);
};